import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import profile from "./Images/Dark Blue and Gold  Circle Logo 1 (2).png";
import API_BASE from "../config/api";

const Setting = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("profile");
  const [institute, setInstitute] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let instituteId = id || localStorage.getItem("instituteId");

    if (!instituteId) {
      setLoading(false);
      return;
    }

    axios
      .get(`${API_BASE}/api/Institutes/${instituteId}`)
      .then(res => setInstitute(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [id]);

  const handleEditClick = () => {
    if (!institute?.id) return;
    navigate(`/dashboard/settingedit/${institute.id}`);
  };

  if (loading) return <p>Loading...</p>;
  if (!institute) return <p>Institute data not found</p>;

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          <span>
            {activeTab === "profile" ? "सेटिंग्ज" : "पेमेंट सेटिंग्ज"}
          </span>
        </h3>
        {activeTab === "profile" && (
          <button className="edit-btn" onClick={handleEditClick}>
            एडिट करा
          </button>
        )}
      </div>

      {/* Tabs */}
      <div className="tabs">
        <button
          className={activeTab === "profile" ? "tab active" : "tab"}
          onClick={() => setActiveTab("profile")}
        >
          संस्था प्रोफाइल
        </button>
        <button
          className={activeTab === "settings" ? "tab active" : "tab"}
          onClick={() => setActiveTab("settings")}
        >
          पेमेंट सेटिंग्ज
        </button>
      </div>

      {/* Profile Tab */}
      {activeTab === "profile" && (
        <>
          <h2>मूलभूत माहिती विभाग</h2>
          <div className="profile-card">
            <img src={profile} alt="institute" className="profile-img" />
            {/* <p className="updated-text">
              Last Updated {new Date(institute.lastUpdated).toLocaleDateString()}
            </p> */}
          </div>

          <div className="info-grid">
            <div className="info-box">
              <label>संस्था नाव</label>
             <p>{institute.instituteName}</p>
            </div>
            <div className="info-box">
  <label>संस्था कोड</label>
  <p>{institute.instituteUniqueId}</p>
</div>
            <div className="info-box">
              <label>प्रमुखाचे नाव (Principal / Head )</label>
             <p>{institute.principleName}</p>
            </div>
            <div className="info-box">
              <label>मोबाईल नं.</label>
             <p>{institute.phoneNumber}</p>
            </div>
            <div className="info-box">
              <label>ईमेल</label>
              <p>{institute.email}</p>
            </div>
            <div className="info-box">
              <label>वेबसाइट</label>
              <p>{institute.website}</p>
            </div>
          </div>

          <h2>पत्ता व ठिकाण विभाग</h2>
          <div className="info-grid">
            <div className="info-box">
              <label>पत्ता</label>
              <p>{institute.address}</p>
            </div>
            {/* <div className="info-box">
              <label>शहर</label>
              <p>{institute.city}</p>
            </div>
            <div className="info-box">
              <label>जिल्हा</label>
              <p>{institute.district}</p>
            </div> */}
          </div>

          <h2>शैक्षणिक माहिती विभाग</h2>
          <div className="info-grid">
            <div className="info-box">
              <label>माध्यम</label>
              <p>{institute.medium}</p>
            </div>
            <div className="info-box">
              <label>उपलब्ध इयत्ता</label>
              <p>{institute.grades}</p>
            </div>
            <div className="info-box">
  <label>एकूण शिक्षक</label>
  <p>{institute.teachersCount}</p>
</div>

<div className="info-box">
  <label>एकूण विद्यार्थी</label>
  <p>{institute.studentsCount}</p>
</div>
          </div>
        </>
      )}

      {/* Settings Tab */}
      {activeTab === "settings" && (
        <>
          <div className="filters">
            <select>
              <option>महिना निवडा</option>
              <option>सप्टेंबर</option>
            </select>
          </div>
          <h2>कमिशन आणि पेमेंट व्यवहार तपशील</h2>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>क्र.</th>
                  <th>व्यवहार आयडी</th>
                  <th>तारीख</th>
                  <th>पुस्तक विक्री रक्कम</th>
                  <th>AKES रक्कम</th>
                  <th>कमिशन %</th>
                  <th>स्थिती</th>
                </tr>
              </thead>
              <tbody>
                {institute.payments?.map((p, index) => (
                  <tr key={p.id}>
                    <td>{index + 1}</td>
                    <td>{p.transactionId}</td>
                    <td>{p.date}</td>
                    <td>{p.bookAmount}</td>
                    <td>{p.akesAmount}</td>
                    <td>{p.commission}</td>
                    <td
                      className={
                        p.status === "जमा" ? "status-green" : "status-gray"
                      }
                    >
                      {p.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Setting;
